import React from "react";
import styled from "styled-components";

import LifeGrid from "../LifeGrid/LifeGrid";

const Main = styled.main`
  width: 100vh;
  height: 100vh;
  width: 100dvw;
  height: 100dvh;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Header = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.25rem 0.5rem;
`;

const HeaderTitle = styled.h1`
  font-size: 2rem;
  line-height: 1.1;
`;

const SubHeader = styled.h2`
  font-size: 0.825rem;
  line-height: 1.1;
  // italicize
  font-style: italic;
  color: var(--color-sky-500);
`;

const Footer = styled.footer`
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: center;
    /* gap: 0.5rem; */
  }
`;

const FooterText = styled.p`
  font-size: 0.8rem;
`;

function App() {
  return (
    <Main>
      <Header>
        <HeaderTitle>More Brian Moore</HeaderTitle>
        <SubHeader>Ad Briani Infinitum</SubHeader>
      </Header>
      <LifeGrid />
      <Footer>
        <FooterText>
          all <a href="https://brianmoore.com">brian moore</a> displayed are
          fair-trade and ethically sourced
        </FooterText>
        <FooterText>
          © 2025-2069 <a href="https://eieio.games">eieio</a>
        </FooterText>
      </Footer>
    </Main>
  );
}

export default App;
